// extracted by mini-css-extract-plugin
export default {"list_item":"DataListItem_list_item__pu788","item_name":"DataListItem_item_name__XEgYz","item_text":"DataListItem_item_text__AxF0B"};